import React, { useEffect, useState } from 'react'
import { Container, Nav, NavDropdown, NavLink, Navbar, Row, Col } from 'react-bootstrap'
import logo from '../resources/logo.jpg';
import { useLocation } from 'react-router-dom'

export default function NavBar() {
  const location = useLocation();
  const [path, setPath] = useState(location.pathname);
  useEffect(() => {


    console.log(path, 'path')
  }, [])
  return (
    <Row>

      <Col style={{ textAlign: "center", backgroundColor: "rgb(170, 74, 68)", color: "rgb(255, 255, 255)" }}>
        <h1 style={{ padding: 0.5 + '%' }}>Free Writing Tool</h1>
      </Col>

      <Navbar style={{ height: '4.5em' }} expand="lg" className="bg-body-primary mt-3">

        <Container style={{ marginLeft: '0.7em', maxWidth: 'unset' }}>

          <Navbar.Brand href="#home" ><Nav.Link as={NavLink} href='/'><img src={logo} alt="logo" style={{ width: '85%' }} /></Nav.Link></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-start justify-content-lg-start" style={{ marginLeft: '-3%' }}>
            <Nav className="me-auto" style={{ fontSize: '21px', fontWeight: '650' }}>
              <Nav.Link as={NavLink} href="/">Home</Nav.Link>
              <Nav.Link as={NavLink} href="/howitworks">How it works</Nav.Link>
              <Nav.Link as={NavLink} href="/aiediting">AI Editing Technology</Nav.Link>
              <Nav.Link as={NavLink} href="/aboutus">About Us</Nav.Link>
              <Nav.Link as={NavLink} href="#">Give us Feedback</Nav.Link>
              <Nav.Link as={NavLink} href="/blogs">Blog</Nav.Link>
              <Nav.Link as={NavLink} href="/contactus">Contact Us</Nav.Link>
            </Nav>
            {/* <Nav className="me-auto" style={{ fontSize: '21px', fontWeight: '650' }}>
              <span id="hrspan">No Cost, No Accounts, No Log-In</span>
            </Nav> */}
          </Navbar.Collapse>

        </Container>
      </Navbar></Row>


  )
}